module.exports = __webpack_public_path__ + "static/media/homeimg2.32a25373.svg";